<template>
  <div>
    <div class="content flex justify-center align-center">
      <a href="http://101.37.16.168/resources/soft/XY-v1.0.1.zip">小Y-v1.0：下载</a>
    </div>
  </div>
</template>

<script>
export default {

  methods: {

  }

}
</script>

<style lang="less" scoped>
.content {
  margin-top: 300px;
  text-align: center;
  font-size: 25px;
}
</style>